import React from "react";
import PropTypes from "prop-types";

import ClientCard from "scenes/Hubly/components/HubModals/components/ClientCard/ClientCard";

import { useWorkDesk } from "../hooks";

const CURVE = "cubic-bezier(0.4, 0, 0.2, 1)";
// sequenced entrance: the hub feed exit plays over a stable feed first,
// then this cross-fade takes over (200ms after a 220ms overlap delay).
// visibility flips visible at t=0 so the layer can paint through the fade.
const ENTER_TRANSITION = `opacity 200ms ${CURVE} 220ms, transform 200ms ${CURVE} 220ms, visibility 0s`;
// exit fades out over 160ms, then hides (out of tab order/a11y tree) after.
const EXIT_TRANSITION = `opacity 160ms ${CURVE}, transform 160ms ${CURVE}, visibility 0s linear 160ms`;

function WorkDeskScreen({ visible, sessionCommand }) {
  const {
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
    workDeskSyncEnabled,
  } = useWorkDesk();

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        borderTop: "1px solid rgba(34, 36, 38, 0.15)",
        // opacity carries the white surface, so the entrance cross-fades
        // from the feed underneath rather than cutting to white
        backgroundColor: "white",
        opacity: visible ? 1 : 0,
        // steady state stays transform-free so the wrapper is not a
        // containing block and holds no permanent compositor layer
        transform: visible ? "none" : "translateY(10px)",
        visibility: visible ? "visible" : "hidden",
        transition: visible ? ENTER_TRANSITION : EXIT_TRANSITION,
      }}
    >
      <ClientCard
        mapPathnameForIframeSrc={parentPathToIframePath}
        mapPathnameFromChild={iframePathToWorkdeskParentPath}
        syncEnabled={workDeskSyncEnabled}
        sessionCommand={sessionCommand}
      />
    </div>
  );
}

WorkDeskScreen.propTypes = {
  visible: PropTypes.bool,
  sessionCommand: PropTypes.shape({
    id: PropTypes.number.isRequired,
    command: PropTypes.string.isRequired,
  }),
};

WorkDeskScreen.defaultProps = {
  visible: false,
  sessionCommand: undefined,
};

export default WorkDeskScreen;
